import {acceptTracking} from '../../api/account'
import getToken from '../account/getToken'

export default store => async (consent) => {
  const token = await getToken(store)()
  if (!token) return

  return acceptTracking(token, consent).then(res => {
    if (!res.ok) {
      throw res
    } else {
      return res.json()
    }
  })
}
